import { NgClass } from '@angular/common';
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FilterDrawerService } from './filter-drawer.service';
import { IDrawerSection } from './filter-drawer.types';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { SlotLoaderComponent } from './slots/slot-loader.component';
import { ZardButtonComponent } from '../ui/button/button.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { TranslocoPipe } from '@ngneat/transloco';
import { SlotRegistry } from './slots/slot-registry.class';

@Component({
    selector: 'filter-drawer',
    templateUrl: './filter-drawer.component.html',
    standalone: true,
    imports: [
        NgClass,
        MatIconModule,
        SlotLoaderComponent,
        FormsModule,
        ReactiveFormsModule,
        ZardButtonComponent,
        TranslocoPipe,
    ],
})
export class FilterDrawerComponent implements OnInit {
    @HostBinding('class') className: string = 'relative';
    @Input() isExpanded = false;
    isManuallyToggled = false;
    isMobile = false;
    filters: IDrawerSection[] = [];
    form: FormGroup = this.fb.group({});

    constructor(
        private breakpointObserver: BreakpointObserver,
        private fb: FormBuilder,
        private _filterDrawerService: FilterDrawerService
    ) {
        this._filterDrawerService.show$.subscribe((show) => {
            this.className = `relative border-r ${show ? '' : 'hidden'}`;
        });

        this._filterDrawerService.filters$.subscribe((filters) => {
            this.filters = filters;
            this.initializeFormControls(filters);
        });

        // Listen to real-time values to restore form state from session storage
        this._filterDrawerService.real_time_values$.subscribe((values) => {
            if (values && this.form) {
                // Update form with restored values, but don't trigger change events
                Object.keys(values).forEach(key => {
                    const control = this.form.get(key);
                    if (control && control.value !== values[key]) {
                        control.setValue(values[key], { emitEvent: false });
                    }
                });
            }
        });

        this.breakpointObserver
            .observe([Breakpoints.Small, Breakpoints.XSmall])
            .subscribe((result) => {
                this.isMobile = result.matches;
            });
    }
    ngOnInit() {
        this.form.valueChanges.subscribe(() => {
            this._filterDrawerService.change(this.form.value);
        });
    }

    initializeFormControls(filters: IDrawerSection[]): void {
        filters.forEach((section) => {
            section.slots.forEach((slot) => {
                const handler = SlotRegistry.getHandler(slot.type);
                handler.registerFormControl(this.form, slot);

                if (slot.defaultValue) {
                    const control = this.form.get(slot.field);
                    if (control) {
                        control.setValue(slot.defaultValue);
                    }
                }
            });
        });
    }

    

    toggleDrawer(): void {
    this.isExpanded = !this.isExpanded;
    this.isManuallyToggled = this.isExpanded;
    }

    save() {
        this._filterDrawerService.submit(this.form.value);
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (this.filters.length > 0) {
                this.save();
            }
        }
    }
    
    reset() {
        const filters = this.filters.flatMap((section) => section.slots);
        const resetValues: { [key: string]: any } = {};

        filters.forEach((slot) => {
            if (slot.defaultValue) {
                resetValues[slot.field] = slot.defaultValue;
            }
        });

        this.form.reset(resetValues);
        this._filterDrawerService.reset();
    }
}